import { LocalStorage } from "quasar"

export default function () {
  return {
    orders: LocalStorage.getItem("orders") || []
  }
}
